import {createAction, createAsyncThunk, createReducer} from '@reduxjs/toolkit';

import {ENDPOINTS} from 'constants/endpoints';
import {AmazonType} from 'desktop/types/amazonV2Type';
import {apiConfig} from 'libs/api/api';
import {AmazonSessionResponseType} from 'types/amazonType';

export const initialState: AmazonType = {
    accessToken: '',
    addressSelect: false,
    auth: false,
    error: '',
    paymentConfirmed: false,
    paymentReady: false,
    sessionInfo: {
        data: null,
        error: '',
        isLoading: false,
    },
};

export const methodAmazonAuth = createAction<boolean>('CHECKOUT@METHOD_AMAZON@AUTH');

export const saveShippingAddressOnAmazonPayment = createAction(
    'CHECKOUT@SAVE_SHIPPING_ADDRESS_ON_AMAZON_PAYMENT',
);

export const methodAmazonPaymentReady = createAction<boolean>(
    'CHECKOUT@METHOD_AMAZON@PAYMENT_READY',
);

export const methodAmazonPaymentConfirmed = createAction<boolean>(
    'CHECKOUT@METHOD_AMAZON@PAYMENT_CONFIRMED',
);

export const methodAmazonAddressSelected = createAction<boolean>(
    'CHECKOUT@METHOD_AMAZON@ADDRESS_SELECT',
);

export const methodAmazonAccessToken = createAction<string>('CHECKOUT@METHOD_AMAZON@ACCESS_TOKEN');

export const methodAmazonSetError = createAction<string>('CHECKOUT@METHOD_AMAZON@SET_ERROR');

export const fetchAmazonSessionInfoToSaga = createAction<string>(
    'CHECKOUT@FETCH_AMAZON@SESSION_INFO_TO_SAGA',
);

export const fetchAmazonSessionInfo = createAsyncThunk<{data: AmazonSessionResponseType}, string>(
    'CHECKOUT@FETCH_AMAZON@SESSION_INFO',
    (sessionId: string) =>
        apiConfig.instanceGusaBackend({
            baseURL: apiConfig.API_URL,
            method: 'get',
            url: `${ENDPOINTS.AMAZON_SESSION_INFO({checkoutSessionId: sessionId})}`,
        }),
);

export const eventAmazonReady = createAction('CHECKOUT@EVENT_AMAZON@READY');

export const eventAmazonAuth = createAction('CHECKOUT@EVENT_AMAZON@AUTH');

/**
 * Amazon reducer
 *
 * @return {AmazonType} - amazon state
 */
export const amazonV2 = createReducer(initialState, builder =>
    builder
        .addCase(fetchAmazonSessionInfo.fulfilled, (state, action) => ({
            ...state,
            sessionInfo: {
                ...state.sessionInfo,
                data: action.payload.data,
                isLoading: false,
            },
            status: 'FULFILLED',
        }))
        .addCase(fetchAmazonSessionInfo.pending, state => ({
            ...state,
            sessionInfo: {
                ...state.sessionInfo,
                isLoading: true,
            },
            status: 'PENDING',
        }))
        .addCase(fetchAmazonSessionInfo.rejected, state => ({
            ...state,
            sessionInfo: {
                ...state.sessionInfo,
                error: 'Something went wrong. Try again later.',
                isLoading: false,
            },
            status: 'REJECTED',
        }))
        .addCase(methodAmazonAccessToken, (state, action) => ({
            ...state,
            accessToken: action.payload,
        }))
        .addCase(methodAmazonAddressSelected, (state, action) => ({
            ...state,
            addressSelect: action.payload,
        }))
        .addCase(methodAmazonAuth, (state, action) => ({
            ...state,
            auth: action.payload,
        }))
        .addCase(methodAmazonPaymentConfirmed, (state, action) => ({
            ...state,
            paymentConfirmed: action.payload,
        }))
        .addCase(methodAmazonPaymentReady, (state, action) => ({
            ...state,
            paymentReady: action.payload,
        }))
        .addCase(methodAmazonSetError, (state, action) => ({
            ...state,
            error: action.payload,
        })),
);
